(function () {
  const headerWrapper = document.querySelector('.header-wrapper');
  const isHomepage = document.body.classList.contains('template-index');

  function getScrollThreshold() {
    if (isHomepage) {
      const banner = document.querySelector('.banner');
      return banner
        ? banner.offsetHeight - headerWrapper.offsetHeight
        : window.innerHeight;
    }
    return 50;
  }

  function handleScroll() {
    const threshold = getScrollThreshold();
    if (window.scrollY > threshold) {
      headerWrapper.classList.add('scrolled');
    } else {
      headerWrapper.classList.remove('scrolled');
    }
  }

  // Suppress scrolled blur when mega menu is open
  function handleMegaMenuToggle() {
    const anyOpen = document.querySelector('.mega-menu[open]');
    headerWrapper.classList.toggle('mega-menu-open', !!anyOpen);
  }

  document.querySelectorAll('.mega-menu').forEach((menu) => {
    menu.addEventListener('toggle', handleMegaMenuToggle);
  });

  window.addEventListener('scroll', handleScroll, { passive: true });
})();
